import { isRegisteredProgramInvitee } from 'models';
import { Card } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { UserLink, UserPopover } from 'features/users/components';
import { useEventInviteesInfiniteQuery } from '../../../queries';
import { EventInviteeAvatar } from '../event-invitee-avatar';

type P = {
  eventId: string;
};

const EventInvitees = ({ eventId }: P) => {
  const { data: allInviteesData, isLoading } = useEventInviteesInfiniteQuery({
    filter: { eventId, status: 'going' },
    pagination: { pageSize: 10 },
  });

  const allInvitees = allInviteesData?.pages
    .flat()
    .flatMap((inviteesPaginated) => inviteesPaginated.data)
    .filter((invitee) => isRegisteredProgramInvitee(invitee));

  if (allInvitees?.length === 0) {
    return null;
  }

  return (
    <>
      {isLoading || !allInvitees ? (
        <Card.HorizontalScroll.EntitySkeleton />
      ) : (
        <Card.HorizontalScroll
          items={allInvitees.map((invitee) => ({
            content: (
              <UserPopover popoverProps={{ stretch: true }} user={invitee}>
                <UserLink userId={invitee.id}>
                  <EventInviteeAvatar user={invitee} />
                </UserLink>
              </UserPopover>
            ),
            key: invitee.id,
          }))}
          title="Latest confirmed invitees"
        />
      )}
    </>
  );
};

export default EventInvitees;
